import { graphql } from '@generated/gql';

export const FETCH_ACCOUNT_SNAPSHOT_LABEL = graphql(/** GraphQL */ `
  query accountSnapshotBreadcrumbFetchAccountSnapshotLabel(
    $accountReconciliationSnapshotId: ObjectID!
  ) {
    fetchAccountReconciliationSnapshot(
      accountReconciliationSnapshotId: $accountReconciliationSnapshotId
    ) {
      accountReconciliationSnapshot {
        account {
          type
          user {
            id
            firstName
            lastName
            entityName
          }
        }
      }
    }
  }
`);
